module.exports = __webpack_public_path__ + "static/img/model-role.9324e5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/model-role.png
// module id = nWzU
// module chunks = 0